export default __webpack_public_path__ + "static/media/flame.7793ff9f.svg";